import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { RoomMixerActions } from "../actions";
import { RoomMixerSelectors } from "../selectors";

@Injectable()
export class RoomMixerFacade {
  roomMixer$ = this.store.pipe(select(RoomMixerSelectors.roomMixer));
  statesHead$ = this.store.pipe(select(RoomMixerSelectors.statesHead));

  constructor(private readonly store: Store) {}

  roomMixerStatesShift() {
    this.store.dispatch(RoomMixerActions.roomMixerStatesShift());
  }
}
